export default __webpack_public_path__ + "static/media/silk_flower.19a23092.png";